<template>
  <div id="homePage">
    <img src="@/assets/homeImg.jpg" alt="homeImg" style="height: 100vh" />
    <div class="homePage-container">
      <!-- 提供多语言培训方案 -->
      <div class="module">
        <div class="text-content">
          <h2>提供多语言培训方案</h2>
          <p>
            我们提供丰富多样的多语言培训方案，涵盖了多种热门语言，通过专业的教学方法和优质的课程内容，帮助学员快速掌握语言技能。
          </p>
          <div class="product-list">
            <div class="product-item">
              <img
                src="@/assets/service1.png"
                alt="Course Icon"
                class="product-icon"
              />
              <p>在线语言课程</p>
            </div>
            <div class="product-item">
              <img
                src="@/assets/service1.png"
                alt="Training Icon"
                class="product-icon"
              />
              <p>线下语言培训</p>
            </div>
            <div class="product-item">
              <img
                src="@/assets/service1.png"
                alt="Tutoring Icon"
                class="product-icon"
              />
              <p>一对一语言辅导</p>
            </div>
          </div>
        </div>
        <div class="image-content">
          <video
            src="@/assets/module1.mp4"
            alt="Language Training Video"
            controls
            preload="metadata"
            style="width: 100%; height: auto; border-radius: 8px"
          ></video>
        </div>
      </div>
      <!-- 为什么选择 Rosetta Stone？ -->
      <div class="module">
        <div class="image-content">
          <video
            src="@/assets/module2.mp4"
            alt="Why Choose Video"
            controls
            preload="metadata"
            style="width: 100%; height: auto; border-radius: 8px"
          ></video>
        </div>
        <div class="text-content">
          <h2>为什么选择 Rosetta Stone？</h2>
          <ul class="advantage-list">
            <li>
              <img
                src="@/assets/service1.png"
                alt="Team Icon"
                class="advantage-icon"
              />
              <span>专业的语言教学团队</span>
            </li>
            <li>
              <img
                src="@/assets/service1.png"
                alt="Method Icon"
                class="advantage-icon"
              />
              <span>先进的语言学习方法</span>
            </li>
            <li>
              <img
                src="@/assets/service1.png"
                alt="System Icon"
                class="advantage-icon"
              />
              <span>完善的课程体系</span>
            </li>
            <li>
              <img
                src="@/assets/service1.png"
                alt="Resource Icon"
                class="advantage-icon"
              />
              <span>丰富的学习资源</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 产品能为你解决的 -->
      <div class="module">
        <div class="text-content">
          <h2>产品能为你解决的</h2>
          <ul class="advantage-list">
            <li>
              <img
                src="@/assets/service1.png"
                alt="Communication Icon"
                class="advantage-icon"
              />
              <span>提升语言沟通能力</span>
            </li>
            <li>
              <img
                src="@/assets/service1.png"
                alt="Career Icon"
                class="advantage-icon"
              />
              <span>助力职业发展</span>
            </li>
            <li>
              <img
                src="@/assets/service1.png"
                alt="Travel Icon"
                class="advantage-icon"
              />
              <span>方便国际旅行</span>
            </li>
            <li>
              <img
                src="@/assets/service1.png"
                alt="Culture Icon"
                class="advantage-icon"
              />
              <span>促进文化交流</span>
            </li>
          </ul>
        </div>
        <div class="image-content">
          <img src="@/assets/service1.png" alt="Solve Problems" />
        </div>
      </div>
      <!-- 使用人群 -->
      <div class="module">
        <div class="image-content">
          <img src="@/assets/service1.png" alt="Users" />
        </div>
        <div class="text-content">
          <h2>适用人群</h2>
          <div class="people-list">
            <div class="people-item">
              <img
                src="@/assets/home/people/student.svg"
                alt="Student Icon"
                class="people-icon"
              />
              <p>学生</p>
            </div>
            <div class="people-item">
              <img
                src="@/assets/home/people/baby.svg"
                alt="Kid Icon"
                class="people-icon"
              />
              <p>幼儿</p>
            </div>
            <div class="people-item">
              <img
                src="@/assets/home/people/basic.svg"
                alt="Beginner Icon"
                class="people-icon"
              />
              <p>零基础学者</p>
            </div>
            <div class="people-item">
              <img
                src="@/assets/home/people/adult.svg"
                alt="Adult Icon"
                class="people-icon"
              />
              <p>成人</p>
            </div>
            <div class="people-item">
              <img
                src="@/assets/home/people/employee.svg"
                alt="Employee Icon"
                class="people-icon"
              />
              <p>企业职工</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 我们为您提供的服务 -->
      <div class="module">
        <div class="text-content">
          <h2>我们为您提供的服务</h2>
          <div class="service-grid">
            <div class="service-card">
              <img src="@/assets/home/service/plan.svg" alt="个性化学习计划" />
              <div class="service-info">
                <h3>个性化学习计划</h3>
                <p>根据学员的需求和水平制定专属学习计划。</p>
              </div>
            </div>
            <div class="service-card">
              <img
                src="@/assets/home/service/progress.svg"
                alt="学习进度跟踪"
              />
              <div class="service-info">
                <h3>学习进度跟踪</h3>
                <p>实时跟踪学员的学习进度，提供及时反馈。</p>
              </div>
            </div>
            <div class="service-card">
              <img
                src="@/assets/home/service/guidance.svg"
                alt="课后辅导服务"
              />
              <div class="service-info">
                <h3>课后辅导服务</h3>
                <p>为学员提供课后的答疑和辅导服务。</p>
              </div>
            </div>
            <div class="service-card">
              <img src="@/assets/home/service/oneToOne.svg" alt="一对一辅导" />
              <div class="service-info">
                <h3>一对一辅导</h3>
                <p>为学员提供一对一外教辅导。</p>
              </div>
            </div>
            <div class="service-card">
              <img src="@/assets/home/service/language.svg" alt="24种语言" />
              <div class="service-info">
                <h3>24种语言</h3>
                <p>总有一种适合你的。</p>
              </div>
            </div>
            <div class="service-card">
              <img src="@/assets/home/service/app.svg" alt="移动应用" />
              <div class="service-info">
                <h3>移动应用</h3>
                <p>学员能够在课堂内外使用智能手机和平板获取课程内容和活动。</p>
              </div>
            </div>
            <div class="service-card">
              <img src="@/assets/home/service/report.svg" alt="报告工具" />
              <div class="service-info">
                <h3>报告工具</h3>
                <p>
                  通过使用进步和完成情况学习报告，即时查看个人、小组和班级表现。
                </p>
              </div>
            </div>
            <div class="service-card">
              <img src="@/assets/home/service/ability.svg" alt="能力测试" />
              <div class="service-info">
                <h3>能力测试</h3>
                <p>在学习开始和过程中使用测试以了解进步程度。</p>
              </div>
            </div>
            <div class="service-card">
              <img src="@/assets/home/service/game.svg" alt="游戏与活动" />
              <div class="service-info">
                <h3>游戏与活动</h3>
                <p>通过好玩又有吸引力的方式强化词汇、语法和发音。</p>
              </div>
            </div>
            <div class="service-card">
              <img
                src="@/assets/home/service/onlineClass.svg"
                alt="真人在线课"
              />
              <div class="service-info">
                <h3>真人在线课</h3>
                <p>基于学生当前的语言水平和学习内容进行针对性练习。</p>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="image-content">-->
        <!--          <img src="@/assets/service1.png" alt="Services" />-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
#homePage {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;

  .homePage-container {
    padding: 20px 10%; /* 增加左右内边距让内容往中间靠 */
  }
}

.module {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  gap: 150px;

  h2 {
    color: #0098db;
    margin-bottom: 10px;
  }

  p {
    color: #333;
  }

  .text-content {
    flex: 1;
  }

  .image-content {
    flex: 1;
  }

  .image-content video {
    width: 100%;
    height: auto;
    border-radius: 8px;
    object-fit: cover;
  }

  .image-content img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
}

.product-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.product-item {
  text-align: center;
  margin-bottom: 10px;
  width: 30%;
}

.product-icon {
  width: 60px;
  height: 60px;
}

.advantage-list {
  list-style: none;
  padding: 0;
}

.advantage-list li {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.advantage-icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 20px;
}

.service-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;

  .service-info {
    text-align: center;
    margin-top: 12px;
  }
}

.service-img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-bottom: 10px;
}

.service-info h3 {
  margin: 0;
  color: #333;
}

.service-info p {
  margin: 0;
  text-align: center;
}

.people-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: 36px;
}

.people-item {
  text-align: center;
  margin-bottom: 10px;
  width: 18%;
}

.people-icon {
  width: 50px;
  height: 50px;
}

/* 视频通用样式 */
.image-content video {
  width: 100%;
  height: auto;
  /* 视频形状和边框相关样式 */
  border: 2px solid #e0e0e0; /* 设置边框宽度、样式和颜色 */
  border-radius: 12px; /* 增加圆角半径，让视频边角更圆润 */
  outline: none; /* 去除视频选中时的默认轮廓 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* 调整阴影效果 */
  transition: all 0.3s ease; /* 过渡效果，让某些属性变化更平滑 */
}

/* 鼠标悬停在视频上时的样式 */
.image-content video:hover {
  transform: scale(1.03); /* 鼠标悬停时稍微放大视频 */
  border-color: #0098db; /* 鼠标悬停时改变边框颜色 */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25); /* 加深阴影效果 */
}
</style>
